<template>
	<div class="speech-wrapper">
		<!-- <div class="banner"><img src="@/assets/images/speech.png" alt="" /></div> -->
		<div class="content">
			<div class="main flex-center">
				<div class="introduce-content">開店講座</div>
				<div class="left">
					<!-- <img src="" alt=""> -->
				</div>
				<div class="right">
					<!-- <img src="" alt=""> -->
				</div>
			</div>
		</div>
		<div class="shop-wrapper ">
			<div class="shop main">
				<div class="shop-left">
					<div class="title">{{ Jzset.title }}</div>
					<div style="white-space: pre-wrap;" class="description">{{ Jzset.detail }}
					</div>
					<div class="info">
						<img src="@/assets/images/item.png" alt="" />
						<div class="info-label">日期</div>
					</div>
					<div class="date">{{ Jzset.date }}</div>
					<div class="info">
						<img src="@/assets/images/clock.png" alt="" />
						<div class="info-label">時間</div>
					</div>
					<div class="time">{{ Jzset.time }}</div>
					<div class="info">
						<img src="@/assets/images/position.png" alt="" />
						<div class="info-label">地點</div>
					</div>
					<div class="address">{{ Jzset.address }}</div>
				</div>
				<div class="shop-right">
					<div v-for="(item, index) in config" :key="index" class="from">
						<div class="label">{{ item.label }}</div>
						<div class="value flex-bt " :class="{ 'error': showError == item.key }">
							<input id="name" v-model="formData[item.key]" :type="item.type"
								:placeholder="item.placeholder" />
							<div v-if="item.type === 'code'" class="code" :class="[item.timer != '60' ? 'disabled' : '']"
								@click="sendCode(item)">{{
									item.buttonText }}</div>
						</div>
					</div>

					<div class="from">
						<div class="label">生意行業</div>
						<select v-model="formData['industry']" :class="{ 'error': showError == 'industry' }"
							class="custom-select">

							<option v-for="opt in options" :value="opt.value" :key="opt.value">{{ opt.label }}
							</option>
						</select>
					</div>
					<div class="from">
						<div class="label">報名場次</div>
						<select v-model="formData['session']" class="custom-select"
							:class="{ 'error': showError == 'session' }">
							<template v-for="option in themes" :value="option.title">
								<option v-if="!option.disabled" :key="option.id">{{ option.title }}
								</option>
							</template>
						</select>
					</div>

					<div class="from">
						<div class="label">您有經營網店或實體店嗎？</div>
						<div class="from-radio">
							<div class="radio">
								<input type="radio" v-model="formData['experience']" value="有" />
								<div class="radio-tiele"> 有</div>
							</div>
							<div class="radio">
								<input type="radio" v-model="formData['experience']" value="無" />
								<div class="radio-tiele">没有</div>
							</div>
						</div>
					</div>
					<div key="findex" class="from">
						<div class="label">您的Facebook 專頁/ Instagram 名稱</div>
						<div class="value flex-bt" :class="{ 'error': showError == 'faceig' }">
							<input id="name" v-model="formData['faceig']" type="text"
								placeholder="您的Facebook 專頁/ Instagram 名稱" />

						</div>
					</div>
					<!-- 					<div class="from">
						<div class="label">您的Facebook 專頁/ Instagram 名稱</div>
						<div class="value">
							<input id="faceig" v-model="formData['faceig']"  type="text"
								:class="{ 'error': showError && formData['faceig'] === '' }"
								placeholder="您的Facebook 專頁/ Instagram 名稱" />
						</div>
					</div> -->
					<div class="pay-attention">* 填妥表格登記，即代表同意所提供之資料可供LOOPSHOP日後作行銷用途。</div>
					<div @click='submitForm' class="button">免費報名</div>
				</div>
			</div>
		</div>
		<div class="theme-wrapper">
			<div class="theme">講座主題</div>
			<div class="case-list main">
				<div class="success-case" v-for="(item, index) in themes" :key="index">
					<div class="date">{{ item.opentime }}</div>
					<div class="title">{{ item.title }}</div>
					<div style="white-space: pre-wrap;" class="process">{{ item.detail }}</div>

					<div @click="selectsession(item)" class="signup" :class="[item.disabled ? 'disabled' : '']">
						{{ item.disabled ? '已結束' : '立即報名' }}</div>
				</div>
			</div>
		</div>
		<SwiperContent></SwiperContent>
		<Start></Start>

		<el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
			<span>報名成功</span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import Start from "@/components/Start.vue"
import SwiperContent from "@/components/SwiperContent.vue"
import { checkFormToast, rules } from 'lonjin-helper'

export default {

	components: { SwiperContent, Start },
	data() {
		return {
			dialogVisible: false,
			Jzset: [],
			caseList: [],
			formData: {
				nickname: '',
				mobile: '',
				email: '',
				industry: '',
				themes: '',
				session: '',
				experience: '',
				faceig: '',
				sjk: 'registration'
			},
			config: [
				{ label: '姓名', placeholder: '請輸入姓名', key: 'nickname', type: 'text' },
				{ label: '電話', placeholder: '請輸入電話', key: 'mobile', type: 'text' },
				// { label: '電話验证码', placeholder: '電話验证码', key: 'mobileCode', type: 'code', buttonText: '發送驗證碼', timer: 60 },
				{ label: '郵箱', placeholder: '請輸入郵箱', key: 'email', type: 'text' },
				// { label: '郵箱验证码', placeholder: '郵箱验证码', key: 'emailCode', type: 'code', buttonText: '發送驗證碼', timer: 60 },
			],
			themes: [
			],
			nowthem: {},
			name: '',
			phone: '',
			showError: false,



			options: [
				{ value: '衣服配飾', label: '衣服配飾' },
				{ value: '電子產品', label: '電子產品' },
				{ value: '酒精飲料', label: '酒精飲料' },
				{ value: '珠寶首飾', label: '珠寶首飾' },
				{ value: '急凍食品', label: '急凍食品' },
				{ value: '育兒產品', label: '育兒產品' },
				{ value: '護膚彩妝', label: '護膚彩妝' },
				{ value: '烘培零食', label: '烘培零食' },
				{ value: '寵物用品', label: '寵物用品' },
				{ value: '運動用品', label: '運動用品' },
				{ value: '玩具書籍', label: '玩具書籍' },
				{ value: '手作產品', label: '手作產品' },
				{ value: '珍饈佳餚', label: '珍饈佳餚' },
				{ value: '其他', label: '其他' },
			],
			selectedOption: '', // 存储选择的选项值
			selectedRadio: null
		};
	},
	mounted() {

		this.getList()
		this.getJzSet()
		// this.getCaseList()
	},
	methods: {
		selectsession(item) {
			if (!item.disabled) {
				this.nowthem = item
				this.formData['session'] = item.title
				window.scrollTo({
					top: 300,
					behavior: 'smooth' // Optional: Adds smooth scrolling animation
				});
			}
		},

		handleClose() {
			this.dialogVisible = !this.dialogVisible
		},


		sendCode(val) {
			if (val.buttonText != '發送驗證碼') return false;
			this.config.map(item => {
				val.key === item.key && (item.timer = 59)
			})
			let timer = setInterval(() => {
				this.config.map(item => {
					if (item.timer != 60) {
						item.timer--
						if (item.timer <= 0) {
							clearInterval(timer)
							item.buttonText = '發送驗證碼'
							item.timer = 60
						} else {
							item.buttonText = `${item.timer}S`
						}
					}
				})
			}, 1000)
		},

		isFutureDate(dateString) {
			const currentDate = new Date();
			const inputDate = new Date(dateString);
			return inputDate > currentDate;
		},

		async submitForm() {
			this.showError = '';
			const mobileRules = (val, message) => {
				const reg = /^\d{8}$/;
				if (!reg.test(val)) return message
			}
			let nickname = rules.isEmpty(this.formData.nickname, '請輸入姓名')
			let mobile = rules.isEmpty(this.formData.mobile, '請輸入電話')
			let isMobile = mobileRules(this.formData.mobile, '請輸入8位電話號碼')
			let email = rules.isEmpty(this.formData.email, '請輸入郵箱')
			let isEmail = rules.isEmail(this.formData.email, '請輸入正確的電郵')
			let industry = rules.isEmpty(this.formData.industry, '請选择生意行業')
			let session = rules.isEmpty(this.formData.session, '請选择報名場次')
			let experience = rules.isEmpty(this.formData.experience, '請选择您有經營網店或實體店')
			let faceig = rules.isEmpty(this.formData.faceig, '請輸入您的Facebook 專頁/ Instagram 名稱')

			const MESSAGE_ENUM = {
				'請輸入姓名': 'nickname',
				'請輸入電話': 'mobile',
				'請輸入8位電話號碼': 'mobile',
				'請輸入郵箱': 'email',
				'請輸入正確的電郵': 'email',
				'請选择生意行業': 'industry',
				'請选择報名場次': 'session',
				'請选择您有經營網店或實體店': 'experience',
				'請輸入您的Facebook 專頁/ Instagram 名稱': 'faceig',
			}

			let result = checkFormToast(nickname, mobile, isMobile, email, isEmail, industry, session, experience, faceig)


			if (result) {
				this.showError = MESSAGE_ENUM[result]
				this.$message.error(result)
			} else {
				// 执行報名逻辑
				console.log('報名成功');
				let res = await this.$api.register(this.formData)
				if (res.code == 1) {
					this.dialogVisible = true
				} else {
					this.$message.error('error');
				}

			}
		},
		async getList() {
			this.showMoreBtn = false
			let fdata = { do: 'json', sjk: 'speechlist', orderby: 'orderid asc', limit: 10 }
			let res = await this.$api.funk(fdata)
			res.forEach(i => {
				i.disabled = !this.isFutureDate(i.opentime)
			})
			console.log('res', res);
			this.themes = res
			this.nowthem = res[0]
		},
		async getCaseList() {
			let fdata = { do: 'json', sjk: 'caselist', orderby: 'orderid asc' }
			let res = await this.$api.funk(fdata)
			this.caseList = res
		},

		async getJzSet() {
			let fdata = { do: 'getset', goto: 'jiangzuoset', orderby: 'orderid asc' }
			let res = await this.$api.funk(fdata)
			this.Jzset = res
		},

	}
};
</script>
<style lang="scss" scoped>
.speech-wrapper {
	.banner {
		width: 100%;
		display: block;

		img {
			width: 100%;
			display: block;
		}
	}

	.content {
		width: 100%;
		height: 4.2rem;
		background: url('~@/assets/images/banner/speech.png')no-repeat center center /100% 100%;
		position: relative;
		background-size: cover;

		.main {
			height: 100%;
		}

		.left {
			width: 4.53rem;
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.right {
			width: 4.53rem;
			position: absolute;
			top: 0;
			right: 0;
			height: 100%;

			img {
				width: 100%;
				height: 100%;
				display: block;
				object-fit: cover;
			}
		}

		.introduce-content {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 600;
			font-size: 0.64rem;
			line-height: 0.64rem;
			color: #000000;
			text-align: center;

			span {
				color: #E02E43;
			}
		}

		.tips {
			font-family: 'PingFang HK';
			font-style: normal;
			font-weight: 400;
			font-size: 0.24rem;
			line-height: 0.34rem;
			text-align: center;
			color: #000000;
			margin-top: 0.16rem;
		}
	}

	.shop-wrapper {
		background: url('~@/assets/images/commerceClassroom-bgs.png')no-repeat center center /100% 100%;

		.shop {
			display: flex;
			justify-content: space-between;

			.shop-left {
				.title {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 600;
					font-size: 0.8rem;
					line-height: 1.12rem;
					color: #000000;
					padding: 1.26rem 0 0.51rem 0rem;
				}

				.description {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.32rem;
					line-height: 0.45rem;
					color: #000000;
					width: 6.20rem;

				}

				.date {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
				}

				.time {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
				}
				.address {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
				}

				.info {
					display: flex;
					align-items: center;
					margin-top: 0.4rem;

					// margin-bottom: ;
					img {
						height: 0.26rem;
					}

					.info-label {
						font-family: 'PingFang HK';
						font-style: normal;
						font-weight: 400;
						font-size: 0.2rem;
						padding-left: 0.12rem;
						color: #E02E43;
					}
				}
			}

			.shop-right {
				width: 5.1rem;
				background: #FFFFFF;
				border: 1px solid #999999;
				border-radius: 0.08rem;
				padding: 0.4rem;
				margin-bottom: 0.41rem;
				margin-top: 0.8rem;

				.pay-attention {
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 400;
					font-size: 0.12rem;
					line-height: 0.17rem;
					/* identical to box height */


					color: #000000;
				}



				input {
					padding: 0 0.16rem;
				}

				.button {
					width: 2.56rem;
					font-family: 'PingFang HK';
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.64rem;
					color: #FFFFFF;
					text-align: center;
					background: #E02E43;
					border-radius: 0.08rem;
					margin: auto;
					margin-top: 0.40rem;
					cursor: pointer;
				}

				.from {
					margin-bottom: 0.16rem;



					.from-radio {
						display: flex;

						.radio {
							display: flex;
							align-items: center;
							margin-top: 0.08rem;

							input {
								width: 0.16rem;
								height: 0.16rem;
								left: 0px;
								top: 0.06rem;
								background: #D9D9D9;
								border: 1px solid #000000;
								display: block;
							}

							.radio-tiele {
								font-family: 'PingFang HK';
								font-style: normal;
								font-weight: 400;
								font-size: 0.2rem;
								line-height: 0.28rem;
								color: #000000;
							}

							input[type="radio"]:checked {
								color: black;
							}
						}

					}

					.label {
						font-family: 'PingFang HK';
						font-style: normal;
						font-weight: 400;
						font-size: 0.20rem;
						line-height: 0.28rem;
						color: #000000;
						margin-bottom: 0.08rem;
					}



					.value {
						width: 4.30rem;
						height: 0.56rem;
						background: #FAFAFA;
						border: 1px solid #999999;
						border-radius: 0.08rem;
						overflow: hidden;

						input {
							flex: 1;
							height: 100%;
						}

						.code {
							background: #e02e43;
							color: #fff;
							width: 1rem;
							height: 0.46rem;
							font-size: 12px;
							text-align: center;
							border-radius: 0.08rem;
							line-height: 0.46rem;
							cursor: pointer;
							margin-right: 0.04rem;

							&.disabled {
								background: #999999;
								cursor: not-allowed;
							}
						}
					}

					select {
						padding: 0 0.16rem;
					}

					input::placeholder {
						font-family: 'Nunito';
						font-style: normal;
						font-weight: 400;
						font-size: 0.16rem;
						line-height: 0.24rem;
						letter-spacing: 0.5px;
						color: #1C1B1F;
					}

					.custom-select {
						display: block;
						width: 100%;
						background: #FFFFFF;
						border: 1px solid #999999;
						border-radius: 0.08rem;
						height: 0.56rem;
					}

					.custom-select option {
						color: red;
						font-size: 0.16rem;
						line-height: 0.24rem;
					}

					.custom-select::placeholder {
						font-family: 'Nunito';
						font-style: normal;
						font-weight: 400;
						font-size: 0.16rem;
						line-height: 0.24rem;
						letter-spacing: 0.5px;
						color: #1C1B1F;

					}
				}



				.error {
					border: 1px solid red !important;
				}

			}


		}
	}

	.theme-wrapper {
		background: #e02e43;
		padding: 1.04rem 0;

		.theme {
			font-family: "PingFang HK";
			font-style: normal;
			font-weight: 600;
			font-size: 0.4rem;
			line-height: 0.56rem;
			margin-bottom: 0.6rem;
			text-align: center;
			color: #ffffff;
		}

		.case-list {
			display: flex;
			flex-wrap: wrap;

			.success-case {
				background: #ffffff;
				border-radius: 0.24rem;
				width: 4rem;
				height: 4.31rem;
				margin-left: 0.4rem;
				margin-bottom: 0.4rem;
				padding: 0.32rem;

				.date {
					font-family: "PingFang HK";
					font-style: normal;
					font-weight: 500;
					font-size: 0.16rem;
					line-height: 0.22rem;

					color: #000000;
				}

				.title {
					font-family: "PingFang HK";
					font-style: normal;
					font-weight: 500;
					font-size: 0.32rem;
					line-height: 0.45rem;
					color: #e02e43;
				}

				.process {
					font-family: "PingFang HK";
					font-style: normal;
					font-weight: 400;
					font-size: 0.24rem;
					line-height: 0.34rem;
					color: #000000;
					margin-top: 0.12rem;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-line-clamp: 5;
					display: -webkit-box;
					min-height: 1.8rem;
					-webkit-box-orient: vertical;
				}

				.signup {
					background: #e02e43;
					border-radius: 0.08rem;
					font-family: "PingFang HK";
					font-style: normal;
					font-weight: 600;
					font-size: 0.24rem;
					line-height: 0.32rem;
					color: #ffffff;
					padding: 0.16rem;
					width: 2.56rem;
					margin: 0 auto;
					margin-top: 0.32rem;
					text-align: center;
					cursor: pointer;

					&.disabled {
						cursor: inherit;
						background: #9f9899;
					}
				}
			}

			.success-case:first-child {
				margin-left: 0rem;
			}

			.success-case:nth-child(4) {
				margin-left: 0rem;
			}
		}
	}
}

@media (max-width: 750px) {
	.speech-wrapper .shop-wrapper .shop {
		display: block;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .description {
		width: 100%;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .info .info-label {
		font-size: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .info img {
		height: 0.3rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-left .date {
		font-size: 0.28rem;
		line-height: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right {
		background: #FFFFFF;
		box-shadow: 0px 0.08rem 0.16rem rgba(0, 0, 0, 0.25);
		border-radius: 0.32rem;
		width: 100%;
		border: none;
		height: auto;
		margin-bottom: 0;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from input {
		width: 100%;
		height: 0.8rem;
		font-size: 0.28rem;
	}

	.speech-wrapper .shop-wrapper {
		padding-bottom: 0.8rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from {
		margin-bottom: 0.32rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .custom-select {
		width: 100%;
		height: 0.8rem;
		position: relative;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .label {
		font-size: 0.28rem;
		line-height: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .from-radio .radio .radio-tiele {
		font-size: 0.24rem;
		line-height: 0.24rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .from .from-radio .radio input {
		width: 0.28rem;
		height: 0.28rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .pay-attention {
		line-height: 0.3rem;
	}

	.speech-wrapper .shop-wrapper .shop .shop-right .button {
		cursor: pointer;
		width: 4rem;
		line-height: 1rem;
		border-radius: 0.2rem;
	}

	.speech-wrapper .shop-wrapper {
		background: url('~@/assets/images/commerceClassroom-mobile.png')no-repeat center center /100% 100%;
	}

	.speech-wrapper .theme-wrapper .case-list {
		display: block;
		padding: 0 0.8rem;
	}

	.speech-wrapper .theme-wrapper .case-list .success-case {
		width: 100%;
		margin: 0;
		margin-bottom: 0.4rem;
		padding: 0.4rem;
		height: auto;
	}

	.speech-wrapper .theme-wrapper .case-list .success-case .date {
		font-size: 0.24rem;
		line-height: 0.24rem;
		margin-bottom: 0.2rem;
	}

	.speech-wrapper .theme-wrapper .case-list .success-case .process {
		font-size: 0.28rem;
		line-height: 0.32rem;
	}

	.speech-wrapper .theme-wrapper .theme {
		font-size: 0.6rem;
		line-height: 0.6rem;
	}

	.content .left,
	.content .right {
		display: none;
	}
}
</style>